import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LogoMaccaferri from '../../../images/LogoMaccaferri.svg';
import LogoMacRODesign from '../../../images/GroundMac_Logo_Negativo.png';
import './Header.scss';
import LanguageButton from './LanguageButton/LanguageButton';
import NewButton from './NewButton/NewButton';
import OpenButton from './OpenButton/OpenButton';
import UserButton from './UserButton/UserButton';
import HorizontalLinearStepper from './Stepper/Stepper';
import { Button, Box } from '@mui/material';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGotoHome = () => {
        navigate('/');
    };

    const handleGotoHub = () => {
        /*         dispatch(cleanResults()); */
        const url = process.env.REACT_APP_EDESIGN_PORTAL_URL as string;
        window.location.replace(url);
    };

    return (
        <header id="header-macro">
            <div className="head">
                <div className="leftHead">
                    <a href="/">
                        <img className="logoMacra" src={LogoMacRODesign} alt="Maccaferri logo header" />
                    </a>
                    <Box sx={{ display: { md: 'flex', sm: 'flex', xs: 'none' } }}>
                        <Button className="backToHub" onClick={handleGotoHub} variant="outlined" startIcon={<DeviceHubIcon />}>
                            {t('header_back_to_hub')}
                        </Button>
                    </Box>
                </div>
                <Box sx={{ display: { md: 'flex', sm: 'none', xs: 'none' }, alignItems: 'center' }}>
                    <button className="cursor-pointer" onClick={handleGotoHome} style={{ background: 'none', border: 'none', padding: 0 }} aria-label="Go to home">
                        <img className="logoMaccaferri" src={LogoMaccaferri} alt="Logo Maccaferri" />
                    </button>
                    {/*}
                    <span style={{ color: '#fff', fontWeight: 500, fontSize: 18, marginLeft: 12 }}>v. 0.92.3</span>
                    */}
                </Box>
            </div>
            <nav className="menu">
                <div>
                    <NewButton className="btn" />
                    <OpenButton className="btn" />
                    {/*allButtonVisible && (
                        <>
                            <SaveButton className='btn' />
                        </>
                    )*/}
                    <LanguageButton className="btn" />
                    {/*}
                    <ExportButton className='btn' />
                    */}
                    {/*}
                    <HelpButton className='btn' />
                        */}
                </div>
                <div className="d-flex">
                    <UserButton />
                    {/*allButtonVisible && <RunButton />*/}
                </div>
            </nav>
            <div>{location.pathname !== '/' && <HorizontalLinearStepper />}</div>
        </header>
    );
};
export default Header;
